<template>
    <div class="form__group">
        <label class="form__label" for="image" v-html="label" v-if="label"></label>
        <div class="form__file">
            <a class="btn is-primary is-small">{{ __('Choose image') }}</a>
            <input id="image" type="file" v-bind:accept="accept" v-on:change="updateImage" />
        </div>
    </div>
</template>

<script>
    export default {
        computed: {
            returnValue: function () {
                return this.value;
            }
        },
        methods: {
            updateImage: function(e) {
                const file = e.target.files[0];
                const reader = new FileReader();

                reader.readAsDataURL(file);
                reader.onload = function () {
                    this.$emit('input', reader.result)
                }.bind(this);
            }
        },
        props: {
            accept: {
                default: null,
                type: String
            },
            label: {
                default: null,
                type: String
            },
            value: {
                required: true,
                type: String
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/elements/FileControl.vue